module.exports = __webpack_public_path__ + "img/server.e0f27c7b.png";